import { xget, xhttp } from "../Fetchv2.js";
import { PGST } from "../schemas/pg.schema-types.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Gallery {
	async getImgs(pgid: PGSchema.pages["id"], queryParams?: { type?: number; limit?: number; size?: number; uid?: string }) {
		let response = await xget<PGSchema.gallery[]>(`/pages/${pgid}/gallery`, queryParams);
		return response;
	}

	// { ok: number | undefined }
	async uploadImg(pgid: PGSchema.pages["id"], ob: any) {
		let response = await xhttp<PGSchema.gallery[]>(`/pages/${pgid}/gallery`, "POST", ob);
		return response;
	}

	async addStorage(pgid: PGSchema.pages["id"], ob: { size: number; url: string; thumb?: string; type: PGST.gallery.type; name?: string }) {
		let response = await xhttp<PGSchema.gallery>(`/pages/${pgid}/gallery/storage`, "POST", ob);
		return response;
	}

	async upImgs(pgid: PGSchema.pages["id"], id: string) {
		let response = await xhttp<{ ok: any; errors: any }>(`/pages/${pgid}/gallery`, "PUT", id);
		return { response: response.response, json: response.json } as any;
	}
	async deleteImgs(bid: PGSchema.pages["id"], id: PGSchema.gallery["id"]) {
		return xhttp<{ ok: number | undefined }>(`/pages/${bid}/gallery`, "DELETE", { id });
	}

	async getStats(pgid: PGSchema.pages["id"]) {
		let response = await xget<{ size: number }>(`/pages/${pgid}/gallery/stats`);
		return response;
	}
}
